(function() {
    // Initialize YouTube API
    if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function initPlayer(wrapper) {
        const thumbnail = wrapper.querySelector('.video-thumbnail-wrapper');
        const videoId = wrapper.dataset.videoid;
        if (!thumbnail || !videoId) return;
        

        // avoid double-binding
        if (thumbnail.dataset.bound === '1') return;
        thumbnail.dataset.bound = '1';

        // Create container for YouTube iframe
        const playerContainer = document.createElement('div');
        playerContainer.id = `youtube-player-${videoId}`;
        wrapper.appendChild(playerContainer);

        // accessibility
        thumbnail.setAttribute('role', 'button');
        thumbnail.setAttribute('tabindex', '0');
        thumbnail.setAttribute('aria-label', 'Play video');

        let player = null;

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        function onPlayerStateChange(event) {
            // When video starts playing
            if (event.data === YT.PlayerState.PLAYING) {
                thumbnail.style.opacity = '0';
                setTimeout(() => thumbnail.remove(), 1000);
            }
        }

        function createPlayer() {
            player = new YT.Player(playerContainer.id, {
                videoId: videoId,
                playerVars: {
                    autoplay: 1,
                    playsinline: 1,
                    rel: 0,
                    controls: 1,
                    enablejsapi: 1
                },
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange
                }
            });
        }

        function activate() {
            if (window.YT && window.YT.Player) {
                createPlayer();
            } else {
                window.onYouTubeIframeAPIReady = createPlayer;
            }
        }

        thumbnail.addEventListener('click', activate);
        thumbnail.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                activate();
            }
        });
    }

    function initYouTubeVideos() {
        document.querySelectorAll('.conecto-youtube-frontend__video-wrapper').forEach(initPlayer);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initYouTubeVideos);
    } else {
        initYouTubeVideos();
    }

    // Handle dynamically added content
    if (window.MutationObserver) {
        new MutationObserver(function(mutations) {
            if (mutations.some(m => m.addedNodes && m.addedNodes.length > 0)) {
                initYouTubeVideos();
            }
        }).observe(document.body, { childList: true, subtree: true });
    }
})();